module.exports = __webpack_public_path__ + "static/media/re_existiendo.f54c8a9c.png";